module.exports = __webpack_public_path__ + "img/icon4.f1a40ae8.gif";